import React, { Component, PropTypes } from 'react';

import { LoadingIndicator } from 'common/components/preloader';
import ModalDialog from 'common/components/modal/modal_dialog';
import Gallery from 'common/components/gallery';
import ResultTile from 'focus_groups/components/result_tile';
import ResultModal from 'focus_groups/containers/result_modal';
import EditEntries from 'focus_groups/containers/edit_entries';
import ResultComments from 'focus_groups/containers/result_comments';

export default class Results extends Component {
  constructor(props) {
    super(props);
    this.onEdit = this.onEdit.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onTileClicked = this.onTileClicked.bind(this);
  }

  onTileClicked(id) {
    this.props.setCurrentRevision(id);
  }

  onEdit() {
    const { group, toggleEditEntries } = this.props;
    const revisionIds = group.revisions.map(({ revision }) => revision.id);
    toggleEditEntries(revisionIds);
  }

  onClose() {
    this.props.toggleEditEntries();
  }

  render() {
    const { group, showEditEntries } = this.props;

    if (!group) {
      return <LoadingIndicator />;
    }

    return (<div className="tab-content results">
              <div className="tab-actions">
                <button className="btn btn-secondary btn-sm" onClick={this.onEdit}>Edit Entries</button>
              </div>
              <ModalDialog
                dialogClasses="focus-group-modal"
                contentClasses="wide"
                modalOpen={showEditEntries}
                closeAction={this.onClose}
                modalHeader={group.name}
              >
                <EditEntries />
              </ModalDialog>
              <Gallery
                classes="row small-up-1 project-entries-gallery list focus-group-results"
                list={group.revisions}
                tile={ResultTile}
                onTileSelect={this.onTileClicked}
              />
              <ResultModal>
                <ResultComments />
              </ResultModal>
            </div>
          );
  }
}

Results.propTypes = {
  group: PropTypes.shape({
    votes: PropTypes.object,
    revisions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  }),
  showEditEntries: PropTypes.bool,
  toggleEditEntries: PropTypes.func.isRequired,
  setCurrentRevision: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./focus_groups/components/results.jsx